import { EUnit } from "./enum/unit";

export class Taxon {

    Code: string;
    NumeroPhase: number;
    SandreCode: number;
    NomGenre: string;
    NomFamille: string;
    NomOrdre: string;

    Quantite: number;
    Unit: EUnit;
    Presence: boolean

    NumeroPrelevement: number;
    Preleve: boolean;
    CustomName: string;

    Instruction: string;
    Comment: string;

    static mapFromJSON(json): Taxon {
        const t = new Taxon();

        t.Code = json.code;
        t.SandreCode = json.sandreCode;
        t.Quantite = json.quantite;
        t.Comment = json.comment
        t.Preleve = json.preleve;
        t.Presence = json.presence
        t.Instruction = json.instruction;
        t.NomFamille = json.nomFamille;
        t.NomGenre = json.nomGenre;
        t.NomOrdre = json.nomOrdre;
        t.NumeroPrelevement = json.numeroPrelevement;
        t.CustomName = json.customName;
        t.Unit = json.unit;
        t.NumeroPhase = json.numeroPhase;

        return t;
    }
}